import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import { Button, Modal, LinkExternal } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

import ModalActions from 'components/ModalActions'
import ModalInput from 'components/ModalInput'
import { getFullDisplayBalance } from 'utils/formatBalance'

interface DepositModalProps {
  max: BigNumber
  onConfirm: (amount: string) => void
  onDismiss: () => void
  tokenName?: string
  addLiquidityUrl?: string
  title?: string
  decimals?: number
}

const CustomButton = styled(Button)`
  background-color: ${(props) => (props.variant === 'secondary' ? 'white' : 'rgb(29, 162, 231)')};
  color: ${(props) => (props.variant === 'secondary' ? 'rgb(29, 162, 231)' : 'white')};
  border: ${(props) => (props.variant === 'secondary' ? '1px solid rgb(29, 162, 231)' : 'none')};
`

const CustomLinkExternal = styled(LinkExternal)`
  color: rgba(178, 96, 220, 1);
`

const DepositWithdrawModal: React.FC<DepositModalProps> = ({
  max,
  onConfirm,
  onDismiss,
  tokenName = '',
  title = '',
  addLiquidityUrl,
  decimals = 18,
}) => {
  const [val, setVal] = useState('')
  const [pendingTx, setPendingTx] = useState(false)
  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(max, decimals)
  }, [max, decimals])

  const valNumber = new BigNumber(val)
  const fullBalanceNumber = new BigNumber(fullBalance)

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (e.currentTarget.validity.valid) {
        setVal(e.currentTarget.value.replace(/,/g, '.'))
      }
    },
    [setVal]
  )

  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])
  return (
    <Modal title={title} onDismiss={onDismiss}>
      <ModalInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={fullBalance}
        symbol={tokenName}
        addLiquidityUrl={addLiquidityUrl}
        inputTitle="Stake"
        decimals={decimals}
      />
      <ModalActions>
        <CustomButton variant="secondary" onClick={onDismiss} width="100%" disabled={pendingTx}>
          Cancel
        </CustomButton>
        <CustomButton
          width="100%"
          disabled={pendingTx || !valNumber.isFinite() || valNumber.eq(0) || valNumber.gt(fullBalanceNumber)}
          onClick={async () => {
            setPendingTx(true)
            await onConfirm(val)
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? 'Pending Confirmation' : 'Confirm'}
        </CustomButton>
      </ModalActions>
      <CustomLinkExternal href={addLiquidityUrl} style={{ alignSelf: 'center' }}>
        Get {tokenName}
      </CustomLinkExternal>
    </Modal>
  )
}

export default DepositWithdrawModal
